export default "__VITE_ASSET__DHAey8vM__"